import { Navigate, Route, Routes } from "react-router-dom";
import { NotFound, Privacy, Terms } from "components/views";
import AccountRoutes from "./AccountRoutes";
import PartnerRoutes from "./PartnerRoutes";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="account/*" element={<AccountRoutes />} />
      <Route path="partner/:partner/*" element={<PartnerRoutes />} />
      <Route path="privacy" element={<Privacy />} />
      <Route path="terms" element={<Terms />} />
      <Route path="notFound" element={<NotFound />} />
      <Route path="/" element={
        <Navigate to="/account/login" replace={true} />
      } />
      <Route path="*" element={
        <Navigate to="/notFound" replace={true} />
      } />
    </Routes>
  );
};

export default AppRoutes;

